import React, { useState } from "react";
import { useSearchBox } from "react-instantsearch";

export default function LcSearchInput({ className, inputRef }) {
  const { query, refine } = useSearchBox();
  const [inputValue, setInputValue] = useState(query);

  const handleChange = (e) => {
    setInputValue(e.target.value);
    refine(e.target.value);
  };

  return (
    <input
      id="learning-center-search"
      name="learning-center-search"
      className={className}
      ref={inputRef}
      value={inputValue}
      type="search"
      placeholder="Search"
      aria-label="Search learning center content"
      autoComplete="off"
      onChange={handleChange}
    />
  );
}
